/* InitialsAvatar - Profile photo or colored initials fallback */

.avatar {
  border-radius: var(--radius-lg);
  overflow: hidden;
  display: grid;
  place-items: center;
  flex-shrink: 0;
}

/* Size variants */
.sm {
  width: 48px;
  height: 48px;
}

.md {
  width: 64px;
  height: 64px;
}

.lg {
  width: 80px;
  height: 80px;
}

/* Photo image */
.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Initials fallback */
.initials {
  color: var(--color-text-primary);
}

.initialsText {
  font-family: var(--font-display);
  font-weight: 600;
  line-height: 1;
}

/* Font size scales with avatar size */
.sm .initialsText {
  font-size: 18px;
}

.md .initialsText {
  font-size: 24px;
}

.lg .initialsText {
  font-size: 32px;
}
